import { LocaleData } from '../../models/locale/locale-data';
import { LandingVariant } from '../../models/landing/variant';

export type ResolvedVariantCopy = {
  banner: string;
  heroCopy: string;
  heroSubCopy1: string;
  heroSubCopy2: string;
  registration: string;
  ctaPhoneText: string;
  /** Variant dial link; undefined = use the locale's base ctaPhoneLink. */
  ctaPhoneLink?: string;
  phoneSubCopy: string;
  onlineCopy: string;
  /** Desktop-only replacement for onlineCopy; undefined = use onlineCopy everywhere. */
  onlineCopyDesktop?: string;
  ctaOnlineText: string;
  phoneNumberAsterix: string[];
  phoneNumberAsterixLinks: string[];
  /** New-UX-only fields; undefined on the live designs. */
  benefitTicks?: string[];
  heroDisclaimer?: string;
  sixtyDayHeader?: string;
  sixtyDayBody?: string;
  linesClosedMessage?: string;
  /** phone-only-v2 (LP1 hybrid) fields; undefined on every other design. */
  offerHeadline?: string[];
  benefitsHeader?: string;
  repeatHeading?: string;
  ctaPhoneRepeatText?: string;
};

/**
 * Merges a locale's base copy with its per-variant overrides (if any) into
 * the full set of strings a landing-page variant renders.
 */
export const getVariantCopy = (data: LocaleData, variant: LandingVariant): ResolvedVariantCopy => {
  const overrides = data.variants?.[variant] ?? {};
  return {
    banner: overrides.banner ?? data.banner,
    heroCopy: overrides.heroCopy ?? data.heroCopy,
    heroSubCopy1: overrides.heroSubCopy1 ?? data.heroSubCopy1,
    heroSubCopy2: overrides.heroSubCopy2 ?? data.heroSubCopy2,
    registration: overrides.registration ?? data.registration,
    ctaPhoneText: overrides.ctaPhoneText ?? data.ctaPhoneText,
    phoneSubCopy: overrides.phoneSubCopy ?? data.phoneSubCopy,
    onlineCopy: overrides.onlineCopy ?? data.onlineCopy,
    onlineCopyDesktop: overrides.onlineCopyDesktop,
    ctaOnlineText: overrides.ctaOnlineText ?? data.ctaOnlineText,
    phoneNumberAsterix: overrides.phoneNumberAsterix ?? data.phoneNumberAsterix,
    phoneNumberAsterixLinks: overrides.phoneNumberAsterixLinks ?? data.phoneNumberAsterixLinks,
    ctaPhoneLink: overrides.ctaPhoneLink,
    benefitTicks: overrides.benefitTicks,
    heroDisclaimer: overrides.heroDisclaimer,
    sixtyDayHeader: overrides.sixtyDayHeader,
    sixtyDayBody: overrides.sixtyDayBody,
    linesClosedMessage: overrides.linesClosedMessage,
    offerHeadline: overrides.offerHeadline,
    benefitsHeader: overrides.benefitsHeader,
    repeatHeading: overrides.repeatHeading,
    ctaPhoneRepeatText: overrides.ctaPhoneRepeatText,
  };
};
